import { PaidResultsFilters } from './widgets/paid-results-filters/PaidResultsFilters'
import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { PaidResultsTable } from './widgets/paid-results-table/PaidResultsTable'
import { useAppSelector } from '../../app/store/hooks/Redux'
import {
  selectAdvertiserReportFilters,
  selectCountry,
  selectProject,
} from './model/paidResultsSlice'
import { PreparingDataStub } from '../../lib/widgets/stubs/PreparingDataStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'
import { selectNotifications } from '../../app/store/reducers/AuthSlice'
import { AffiliateTrackingStub } from '../../lib/widgets/stubs/AffiliateTrackingStub'
import { AdvertiserReportFilterInterface } from './model/types/AdvertiserReportFilter.interface'
import { useMemo } from 'react'
import clsx from 'clsx'

import styles from './PaidResultsPage.module.scss'
import { MissingKeywordsStub } from '../../lib/widgets/stubs/MissingKeywordsStub'
import { useTranslation } from 'react-i18next'

export const PaidResultsPage = () => {
  const { t } = useTranslation()
  const { value: projectId, has_paid_links: hasPaidLinks } = useAppSelector(selectProject)
  const currentCountry = useAppSelector(selectCountry)
  const { policy } = useAppSelector<AdvertiserReportFilterInterface>(selectAdvertiserReportFilters)
  const notifications = useAppSelector(selectNotifications)

  const showTrackingStub = useMemo(() => {
    const trackingDisabled = notifications?.some(
      (value) =>
        String(value.project_id) === projectId && value.type === 'affiliate_tracking_disabled',
    )
    const trackingSetup =
      policy === 'non_compliant_affiliates' &&
      notifications?.some(
        (value) =>
          String(value.project_id) === projectId && value.type === 'affiliate_tracking_setup',
      )

    return trackingDisabled ? false : trackingSetup
  }, [policy, notifications, projectId])

  const showKeywordStub = currentCountry?.keywords_state === 'never'

  const state = showTrackingStub
    ? 'tracking-stub'
    : showKeywordStub
      ? 'keyword-stub'
      : hasPaidLinks
        ? 'table'
        : 'project-stub'

  const content = {
    'tracking-stub': (
      <StubLayout>
        <AffiliateTrackingStub changeLocation project={projectId} />
      </StubLayout>
    ),
    'keyword-stub': (
      <StubLayout>
        <MissingKeywordsStub project={projectId} />
      </StubLayout>
    ),
    table: <PaidResultsTable />,
    'project-stub': (
      <StubLayout>
        <PreparingDataStub />
      </StubLayout>
    ),
  }[state]

  return (
    <CommonMainPage hint={t('navigation.hint.paidSearch')} title={t('navigation.paidSearch')}>
      <section className={clsx(styles.wrapper)}>
        <PaidResultsFilters />
        {content}
      </section>
    </CommonMainPage>
  )
}
